import angular from 'angular';
import './CreateMessageTemplateSidebar.scss';
import messageTemplateLanguagesJson from './messageTemplateLanguages.json';
import { MessageTemplateFeatures } from '../MessageTemplateFeatures';
import { MessageTemplateButtonTypes, getTrackedButtonType, } from '../models/MessageTemplateButtons';
import { MessageTemplateSampleModalController } from '../messageTemplateSamples/MessageTemplateSampleModalController';
import MessageTemplateSampleModalHtml from '../messageTemplateSamples/MessageTemplateSampleModalHtml.html';
import { getOtpButtonText, TRANSLATIONS_MAP } from '../shared/LanguageMapping';
import { MessageTemplateModalBuilder, } from './MessageTemplateModalBuilder';
const TRANSACTIONAL = 'TRANSACTIONAL';
const MARKETING = 'MARKETING';
const OTP = 'OTP';
const AUTHENTICATION = 'AUTHENTICATION';
const UTILITY = 'UTILITY';
const TEMPLATE_NAME_ALREADY_EXIST_ERROR_CODE = '2388024';
const CATEGORY_DOESNT_MATCH_ERROR_CODE = '2388026';
const COMMAND_INVALID_ARGUMENT_CODE = 64;
const INVALID_SIZE_ERROR_TEXT = 'Attachments larger than';
const UNSUPPORTED_TYPE_ERROR_TEXT = 'Attachments with type';
const MISMATCHED_TYPE_ERROR_TEXT = 'Expected the attachment type';
export const MessageTemplateContentTypes = {
    DEFAULT: 'default',
    TEXT: 'text',
    IMAGE: 'image',
    DOCUMENT: 'document',
    VIDEO: 'video',
    PAYMENT: 'payment',
    CAROUSEL: 'carousel',
};
const MIN_META_BID_VALUE = 0.01;
const META_BID_INCREMENT = 0.1;
export class CreateMessageTemplateSidebarController {
    static $inject = ['close', 'AccountService2', 'messageTemplate', 'messageTemplates', 'type', 'application', '$translate', 'MessageTemplateService', 'MessageTemplateSegmentService', 'ModalService', 'LoadingService', 'onSaveMessageTemplate', 'BlipToastService', 'AlertService', '$scope'];
    isPaymentCardHeaderValid() {
        if (this.messageTemplateType !== 'payment')
            return true;
        const paymentCardController = this.getPaymentCardController();
        if (paymentCardController &&
            typeof paymentCardController.isHeaderValid === 'function') {
            return (paymentCardController.isConfirmed &&
                paymentCardController.isHeaderValid());
        }
        return false;
    }
    constructor(close, AccountService2, messageTemplate, messageTemplates, type, application, $translate, MessageTemplateService, MessageTemplateSegmentService, ModalService, LoadingService, onSaveMessageTemplate, BlipToastService, AlertService, $scope) {
        this.close = close;
        this.AccountService2 = AccountService2;
        this.messageTemplate = messageTemplate;
        this.messageTemplates = messageTemplates;
        this.type = type;
        this.application = application;
        this.$translate = $translate;
        this.MessageTemplateService = MessageTemplateService;
        this.MessageTemplateSegmentService = MessageTemplateSegmentService;
        this.ModalService = ModalService;
        this.LoadingService = LoadingService;
        this.onSaveMessageTemplate = onSaveMessageTemplate;
        this.BlipToastService = BlipToastService;
        this.AlertService = AlertService;
        this.$scope = $scope;
        this.headerType = 'text';
        this.showFooter = false;
        this.buttonType = MessageTemplateButtonTypes.DEFAULT;
        this.isNewMessageAttachmentRouteEnabled = MessageTemplateFeatures.newMessageAttachmentRouteEnabledDefaultValue;
        this.isMessageTemplatePaymentEnabled = false;
        this.isMessageTemplatePaymentCardEnabled = false;
        this.isMessageTemplateCarouselEnabled = false;
        this.metaBidValue = MIN_META_BID_VALUE;
        this.isMetaBidValid = true;
        this.metaBidDisplayValue = MIN_META_BID_VALUE.toFixed(2).replace('.', ',');
        this.isMetaPricingEnabled = false;
        this.isEmptyCategory = () => !this.messageTemplate.category;
        this.isAuthenticationType = () => this.messageTemplate.category == AUTHENTICATION;
        this.isUtilityType = () => this.messageTemplate.category == UTILITY;
        this.formatDecimalMask = (value) => {
            let cleanValue = value.replace(/\D/g, '');
            if (!cleanValue)
                return '';
            if (cleanValue.length > 6) {
                cleanValue = cleanValue.substring(0, 6);
            }
            if (cleanValue.length === 1) {
                cleanValue = '00' + cleanValue;
            }
            else if (cleanValue.length === 2) {
                cleanValue = '0' + cleanValue;
            }
            const integerPart = cleanValue.slice(0, -2) || '0';
            const decimalPart = cleanValue.slice(-2);
            return `${integerPart},${decimalPart}`;
        };
        this.parseDecimalValue = (displayValue) => {
            const cleanValue = displayValue.replace(',', '.');
            const numericValue = parseFloat(cleanValue) || 0;
            return Math.round(numericValue * 100) / 100;
        };
        this.onMetaBidInput = (event) => {
            let inputValue = event.target.value;
            const sanitizedValue = inputValue.replace(/[^\d,]/g, '');
            const commaCount = (sanitizedValue.match(/,/g) || []).length;
            if (commaCount > 1) {
                const firstCommaIndex = sanitizedValue.indexOf(',');
                inputValue =
                    sanitizedValue.substring(0, firstCommaIndex + 1) +
                        sanitizedValue.substring(firstCommaIndex + 1).replace(/,/g, '');
            }
            else {
                inputValue = sanitizedValue;
            }
            if (inputValue.includes(',')) {
                const [integerPart, decimalPart] = inputValue.split(',');
                if (decimalPart && decimalPart.length > 2) {
                    inputValue = `${integerPart},${decimalPart.substring(0, 2)}`;
                }
            }
            else if (inputValue.length >= 3 && inputValue.startsWith('0')) {
                const cleanDigits = inputValue.replace(/\D/g, '');
                if (cleanDigits.length >= 3) {
                    const integerPart = cleanDigits.slice(0, -2) || '0';
                    const decimalPart = cleanDigits.slice(-2);
                    inputValue = `${integerPart},${decimalPart}`;
                }
            }
            this.metaBidDisplayValue = inputValue;
            this.metaBidValue = this.parseDecimalValue(inputValue);
            this.isMetaBidValid = this.metaBidValue >= MIN_META_BID_VALUE;
            if (event.target.value !== inputValue) {
                event.target.value = inputValue;
            }
        };
        this.onMetaBidChange = () => {
            const numericValue = this.parseDecimalValue(this.metaBidDisplayValue);
            this.metaBidValue = numericValue;
            this.isMetaBidValid = numericValue >= MIN_META_BID_VALUE;
            if (this.metaBidDisplayValue && numericValue > 0) {
                this.metaBidDisplayValue = numericValue
                    .toFixed(2)
                    .replace('.', ',');
            }
        };
        this.incrementMetaBid = () => {
            this.metaBidValue =
                Math.round((this.metaBidValue + META_BID_INCREMENT) * 100) / 100;
            this.metaBidDisplayValue = this.metaBidValue
                .toFixed(2)
                .replace('.', ',');
            this.isMetaBidValid = this.metaBidValue >= MIN_META_BID_VALUE;
        };
        this.decrementMetaBid = () => {
            const newValue = Math.round((this.metaBidValue - META_BID_INCREMENT) * 100) / 100;
            this.metaBidValue = Math.max(MIN_META_BID_VALUE, newValue);
            this.metaBidDisplayValue = this.metaBidValue
                .toFixed(2)
                .replace('.', ',');
            this.isMetaBidValid = this.metaBidValue >= MIN_META_BID_VALUE;
        };
        this.isMetaBidDecrementDisabled = () => {
            return this.metaBidValue <= MIN_META_BID_VALUE;
        };
        this.isMarketingCategorySelected = () => {
            return this.messageTemplate.category === MARKETING;
        };
        this.shouldShowMetaPricing = () => {
            return (this.isMetaBiddingAlphaEnabled && this.isMarketingCategorySelected());
        };
        this.onMetaPricingToggle = (event) => {
            this.isMetaPricingEnabled = event.target.checked;
            // Reset bid values when disabling
            if (!this.isMetaPricingEnabled) {
                this.metaBidValue = MIN_META_BID_VALUE;
                this.metaBidDisplayValue = MIN_META_BID_VALUE.toFixed(2).replace('.', ',');
                this.isMetaBidValid = true;
            }
        };
        this.initialize();
    }
    isValidOtpButtonText(text) {
        if (!text)
            return true; // Accepts empty for Meta auto-translation
        const hasNewlines = /[\n\r]/.test(text);
        const hasVariables = /\{\{(?=([^}]*))\1\}\}/.test(text);
        const hasFormatting = /[*~]/.test(text);
        const hasEmojis = /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(text);
        return !(hasNewlines || hasVariables || hasFormatting || hasEmojis);
    }
    async initialize() {
        this.messageTemplateType = this.type;
        await this.checkFeatures();
        await this.fillTemplateCategories();
        await this.fillTemplateLanguages();
        await this.setSelectDefaultLanguage();
        this.invalidTranlationLanguages = [];
        this.verifyButtonOption();
        this.verifyButtonType();
        // Watch for language changes in translations to trigger UI updates
        this.$scope.$watch(() => this.messageTemplate.translations.map(t => t.language).join(','), (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.$scope.$applyAsync();
            }
        });
        document.body.classList.add('sidebar-open');
    }
    async checkFeatures() {
        this.isMessageTemplateVideoEnabled = await MessageTemplateFeatures.isMessageTemplateVideoEnabled();
        this.isMessageTemplateMarketingCategoriesEnabled = await MessageTemplateFeatures.isMessageTemplateMarketingCategoriesEnabled();
        this.isMediaMessageTemplateEnabled = await MessageTemplateFeatures.isMediaMessageTemplateEnabled();
        this.isNewMessageAttachmentRouteEnabled = await MessageTemplateFeatures.isNewMessageAttachmentRouteEnabled();
        this.isNewestMessageTemplateCategoriesEnabled = await MessageTemplateFeatures.isNewestMesssageTemplateCategoriesEnabled();
        this.isMessageTemplateCategoryAuthenticationEnabled = await MessageTemplateFeatures.isMessageTemplateAuthenticationCategoryEnabled();
        this.isMessageTemplateAiAnalysisEnabled = await MessageTemplateFeatures.isMessageTemplateAiAnalysisEnabled();
        this.isMessageTemplatePaymentEnabled = await MessageTemplateFeatures.isMessageTemplatePaymentEnabled();
        this.isMetaBiddingAlphaEnabled = await MessageTemplateFeatures.isMetaBiddingAlphaEnabled();
        this.isMessageTemplateCarouselEnabled = await MessageTemplateFeatures.isMessageTemplateCarouselEnabled();
    }
    verifyButtonType() {
        const button = this.messageTemplate.translations[0]?.buttons?.[0];
        if (button) {
            this.buttonType =
                button.type.toLowerCase() ===
                    MessageTemplateButtonTypes.QUICK_REPLY
                    ? button.type.toLowerCase()
                    : MessageTemplateButtonTypes.CALL_TO_ACTION;
        }
    }
    verifyButtonOption() {
        const buttons = this.messageTemplate.translations[0].buttons;
        if (buttons) {
            this.options = buttons;
        }
    }
    setSidebarHeight() {
        const windowHeight = window.innerHeight;
        const contentElements = document.getElementsByClassName('main-section');
        if (contentElements.length === 0)
            return;
        const contentElement = contentElements[0];
        const contentTop = contentElement.getBoundingClientRect().top;
        const header = document.getElementById('main-navbar');
        const headerBounding = header.getBoundingClientRect();
        const headerDown = headerBounding.height - headerBounding.bottom;
        const sidebar = document.getElementById('create-message-template-sidebar');
        const sidebarTop = contentTop >= 0 ? contentTop : 0;
        const contentHTMLElement = contentElement;
        const sidebarHeight = contentTop <= 0
            ? '100%'
            : windowHeight -
                contentHTMLElement['offsetTop'] +
                headerDown +
                'px';
        sidebar?.setAttribute('style', `top: ${sidebarTop}px; height: ${sidebarHeight}`);
    }
    async setSelectDefaultLanguage() {
        const userLanguage = (await this.AccountService2.me()).culture;
        this.messageTemplate.translations.map(translation => {
            if (!translation.language) {
                translation.language = userLanguage.replace(/-/i, '_');
            }
        });
    }
    async fillTemplateCategories() {
        if (this.isNewestMessageTemplateCategoriesEnabled) {
            this.templateCategories = [];
            if (this.isMessageTemplateCategoryAuthenticationEnabled) {
                this.templateCategories.push({
                    label: await this.$translate('messageTemplate.categories.' + AUTHENTICATION),
                    value: AUTHENTICATION,
                });
            }
            this.templateCategories.push({
                label: await this.$translate('messageTemplate.categories.' + MARKETING),
                value: MARKETING,
            });
            this.templateCategories.push({
                label: await this.$translate('messageTemplate.categories.' + UTILITY),
                value: UTILITY,
            });
        }
        else {
            this.templateCategories = [
                {
                    label: await this.$translate('messageTemplate.categories.' + TRANSACTIONAL),
                    value: TRANSACTIONAL,
                },
                {
                    label: await this.$translate('messageTemplate.categories.' + MARKETING),
                    value: MARKETING,
                },
                {
                    label: await this.$translate('messageTemplate.categories.' + OTP),
                    value: OTP,
                },
            ];
        }
    }
    async fillTemplateLanguages() {
        const promises = [];
        this.templateLanguages = [];
        messageTemplateLanguagesJson.forEach(l => {
            promises.push(this.$translate('messageTemplateLanguages.' + l).then(translation => {
                this.templateLanguages.push({
                    label: translation,
                    value: l,
                });
            }));
        });
        await Promise.all(promises);
        this.templateLanguages.sort((a, b) => a.label > b.label ? 1 : b.label > a.label ? -1 : 0);
    }
    switchTemplateType(typeName) {
        this.messageTemplateType = typeName;
    }
    async closeSidebar() {
        if (!this.isMessageTemplatePristine()) {
            await this.AlertService.show({
                title: await this.$translate('messageTemplate.modal.closeNoSaveModal.title'),
                body: await this.$translate('messageTemplate.modal.closeNoSaveModal.text'),
                variant: 'warning',
                icon: 'info',
                buttons: {
                    cancel: await this.$translate('messageTemplate.modal.closeNoSaveModal.cancelButton'),
                    confirm: await this.$translate('messageTemplate.modal.closeNoSaveModal.confirmButton'),
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: async () => {
                        await this.close();
                        document.body.classList.remove('sidebar-open');
                    },
                },
            });
        }
        else {
            await this.close();
            document.body.classList.remove('sidebar-open');
        }
    }
    isMessageTemplatePristine() {
        const isThereTranslation = this.messageTemplate.translations.filter(t => t && (t.language || t.text)).length > 0;
        return (!this.messageTemplate.name &&
            !this.messageTemplate.category &&
            !isThereTranslation);
    }
    addTranslation() {
        this.MessageTemplateSegmentService.trackNewTranslationAdded();
        const newButtonsArray = angular.copy(this.options);
        this.messageTemplate.translations.push({
            language: '',
            text: '',
            status: '',
            imageLink: '',
            documentLink: this.documentLink,
            videoLink: this.videoLink,
            buttons: newButtonsArray,
            qualityScore: {
                date: 0,
                score: '',
            },
        });
    }
    removeTranslation(index) {
        this.messageTemplate.translations.splice(index, 1);
        this.checkRepeatedLanguage();
    }
    checkRepeatedLanguage() {
        const languagesInUse = this.messageTemplate.translations
            .map(t => t.language)
            .slice()
            .sort();
        this.invalidTranlationLanguages = [];
        for (let i = 0; i < languagesInUse.length - 1; i++) {
            if (languagesInUse[i + 1] == languagesInUse[i] &&
                languagesInUse[i] != '') {
                this.invalidTranlationLanguages.push(languagesInUse[i]);
            }
        }
    }
    isTemplateNameInvalid() {
        this.invalidTemplateName = false;
        this.usedTemplateName = false;
        this.invalidMaxLengthName = false;
        const regex = /^[a-z]([a-z0-9_])*$/g;
        const match = this.messageTemplate.name.match(regex);
        if (!match) {
            this.invalidTemplateName = true;
        }
        if (this.messageTemplate.name.length > 512) {
            this.invalidMaxLengthName = true;
        }
        this.messageTemplate.name = this.messageTemplate.name.trim();
        this.messageTemplates.forEach(template => {
            if (template.name == this.messageTemplate.name) {
                this.usedTemplateName = true;
            }
        });
    }
    areTranslationsValid() {
        if (this.isAuthenticationType()) {
            return (this.messageTemplate.translations.filter(t => t?.language).length == this.messageTemplate.translations.length);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.TEXT ||
            this.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
            return (this.messageTemplate.translations.filter(t => t?.language && t?.text).length == this.messageTemplate.translations.length);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.IMAGE) {
            return (this.messageTemplate.translations.filter(t => t?.language && t?.text && t?.imageLink).length == this.messageTemplate.translations.length);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.DOCUMENT) {
            return (this.messageTemplate.translations.filter(t => t?.language && t?.text && t?.documentLink).length == this.messageTemplate.translations.length);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.VIDEO) {
            return (this.messageTemplate.translations.filter(t => t?.language && t?.text && t?.videoLink).length == this.messageTemplate.translations.length);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL) {
            return (this.messageTemplate.translations.filter(t => t?.language && t?.bodyText && t?.cards?.length >= 2).length == this.messageTemplate.translations.length);
        }
        return false;
    }
    areLanguagesValid() {
        return (this.invalidTranlationLanguages &&
            this.invalidTranlationLanguages.length == 0);
    }
    isMessageTemplateValid() {
        const isTemplateNameValid = !this.invalidTemplateName && !this.usedTemplateName;
        if (!this.messageTemplate.name) {
            return false;
        }
        return (isTemplateNameValid &&
            !this.invalidMaxLengthName &&
            this.messageTemplate.category &&
            this.areTranslationsValid() &&
            this.areLanguagesValid() &&
            this.isMetaBidValid);
    }
    thereTranslations() {
        return this.messageTemplate.translations.length > 1;
    }
    isTranslationCard(index) {
        return index > 0;
    }
    replaceNewLines(value) {
        const searchLineBreaks = value.match(/\n/gm);
        searchLineBreaks &&
            searchLineBreaks.map(lineBreak => {
                value = value.replace(lineBreak, '\\n');
            });
        return value;
    }
    validateButtonText(buttonText) {
        const isOtpButton = this.messageTemplate.category === AUTHENTICATION;
        if (isOtpButton) {
            // For OTP buttons, accept valid translations or empty/undefined for Meta auto-translation
            if (!buttonText || buttonText.trim() === '') {
                return true;
            }
            // Build valid texts from i18n files
            const validOtpTexts = Object.values(TRANSLATIONS_MAP)
                .map(t => t.messageTemplateCard?.copyButton)
                .filter(Boolean);
            // Check for invalid characters
            const hasInvalidChars = /[*~\n{}]|\{\{|\}\}/.test(buttonText);
            const hasEmojis = /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(buttonText);
            if (hasInvalidChars || hasEmojis) {
                return false;
            }
            return validOtpTexts.includes(buttonText.trim());
        }
        // Default validation for other categories
        const invalidCharacters = /[*~\n{}]/;
        return !invalidCharacters.test(buttonText);
    }
    async saveTemplate(variables = [], buttonsVariables = [], headerVariables = [], cardVariables = [], cardButtonVariables = []) {
        try {
            this.LoadingService.startLoading();
            const attachmentComponents = await this.buildAttachmentComponents(headerVariables, cardVariables, cardButtonVariables);
            if (attachmentComponents.hasError) {
                return;
            }
            await this.createAndSaveTemplates(attachmentComponents.components, variables, buttonsVariables);
            await this.handleSaveSuccess();
        }
        catch (error) {
            await this.handleSaveError(error);
        }
    }
    async buildAttachmentComponents(headerVariables, cardVariables, cardButtonVariables = []) {
        const components = [];
        let hasError = false;
        const simpleMediaComponent = await this.buildSimpleMediaHeaderComponent();
        if (simpleMediaComponent.hasError) {
            hasError = true;
        }
        else if (simpleMediaComponent.component) {
            components.push(simpleMediaComponent.component);
        }
        // Validate OTP button texts for all translations before processing
        if (this.isAuthenticationType()) {
            for (const msg of this.messageTemplate.translations) {
                const buttonText = getOtpButtonText(msg.language);
                if (buttonText && !this.isValidOtpButtonText(buttonText)) {
                    const errorText = await this.$translate('messageTemplateSidebar.newTemplate.toasts.error.invalidOtpButtonText');
                    this.BlipToastService.show('danger', {
                        msg: errorText,
                    });
                    this.LoadingService.stopLoading();
                    return { components, hasError: true };
                }
            }
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
            const paymentComponents = await this.buildPaymentHeaderComponents(headerVariables);
            components.push(...paymentComponents);
        }
        if (this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL) {
            const carouselComponent = await this.buildCarouselComponents(cardVariables, cardButtonVariables);
            if (carouselComponent) {
                components.push(carouselComponent);
            }
        }
        return { components, hasError };
    }
    async buildSimpleMediaHeaderComponent() {
        const shouldBuildMedia = this.messageTemplateType !== MessageTemplateContentTypes.TEXT &&
            this.messageTemplateType !== MessageTemplateContentTypes.PAYMENT &&
            this.messageTemplateType !== MessageTemplateContentTypes.CAROUSEL &&
            !this.isAuthenticationType();
        if (!shouldBuildMedia) {
            return { component: null, hasError: false };
        }
        const uri = this.getMediaUri();
        const fileHandle = await this.uploadAttachment(uri);
        if (!fileHandle) {
            this.LoadingService.stopLoading();
            return { component: null, hasError: true };
        }
        return {
            component: {
                type: 'HEADER',
                format: this.messageTemplateType.toUpperCase(),
                example: {
                    header_handle: [fileHandle],
                },
            },
            hasError: false,
        };
    }
    getMediaUri() {
        switch (this.messageTemplateType) {
            case MessageTemplateContentTypes.IMAGE:
                return this.imageLink;
            case MessageTemplateContentTypes.DOCUMENT:
                return this.documentLink;
            case MessageTemplateContentTypes.VIDEO:
                return this.videoLink;
            default:
                return '';
        }
    }
    async buildPaymentHeaderComponents(headerVariables) {
        const components = [];
        const paymentSettings = this.getCurrentPaymentCardSettings();
        if (paymentSettings.headerType === 'text' && this.getCurrentHeaderValue()) {
            const textComponent = this.buildPaymentTextHeader(headerVariables);
            if (textComponent) {
                components.push(textComponent);
            }
        }
        else if (paymentSettings.headerType === 'image' && paymentSettings.imageLink) {
            const imageComponent = await this.buildPaymentImageHeader(paymentSettings.imageLink);
            if (imageComponent) {
                components.push(imageComponent);
            }
        }
        else if (paymentSettings.headerType === 'document' && paymentSettings.documentLink) {
            const documentComponent = await this.buildPaymentDocumentHeader(paymentSettings.documentLink);
            if (documentComponent) {
                components.push(documentComponent);
            }
        }
        return components;
    }
    buildPaymentTextHeader(headerVariables) {
        const headerText = this.getCurrentHeaderValue();
        if (headerVariables.length === 0) {
            return null;
        }
        return {
            type: 'HEADER',
            format: 'TEXT',
            text: this.replaceNewLines(headerText),
            example: {
                header_text: headerVariables,
            },
        };
    }
    async buildPaymentImageHeader(imageLink) {
        const imageHandle = await this.uploadAttachment(imageLink);
        if (!imageHandle) {
            return null;
        }
        return {
            type: 'HEADER',
            format: 'IMAGE',
            example: {
                header_handle: [imageHandle],
            },
        };
    }
    async buildPaymentDocumentHeader(documentLink) {
        const documentHandle = await this.uploadAttachment(documentLink);
        if (!documentHandle) {
            return null;
        }
        return {
            type: 'HEADER',
            format: 'DOCUMENT',
            example: {
                header_handle: [documentHandle],
            },
        };
    }
    async buildCarouselComponents(cardVariables, cardButtonVariables = []) {
        let carouselCardsPromises = [];
        const cards = this.messageTemplate.translations[0].cards;
        if (!cardVariables || cardVariables.length === 0) {
            carouselCardsPromises = cards.map(async (card, cardIndex) => {
                const buttonVars = cardButtonVariables?.[cardIndex] ?? [];
                return await this.buildCarouselCard(card, [], buttonVars);
            });
        }
        else {
            carouselCardsPromises = cardVariables.map(async (variables, cardIndex) => {
                const buttonVars = cardButtonVariables?.[cardIndex] ?? [];
                return await this.buildCarouselCard(cards[cardIndex], variables, buttonVars);
            });
        }
        const carouselCards = await Promise.all(carouselCardsPromises);
        return {
            type: 'carousel',
            cards: carouselCards,
        };
    }
    async buildCarouselCard(card, variables, buttonVariables = []) {
        const cardComponents = [];
        const fileHandle = await this.uploadAttachment(card.mediaLink);
        cardComponents.push({
            type: 'header',
            format: card.carouselType,
            example: {
                header_handle: [fileHandle],
            },
        });
        cardComponents.push({
            type: 'body',
            text: this.replaceNewLines(card.text),
            ...(variables.length > 0 && { example: {
                    body_text: [variables],
                } }),
        });
        const buttonsComponent = {
            type: 'buttons',
            buttons: card.buttons.map((button, buttonIndex) => {
                const btnConfig = {
                    type: button.type,
                    text: button.text,
                };
                if (button.phone_number) {
                    btnConfig.phone_number = button.phone_number;
                }
                if (button.url) {
                    btnConfig.url = button.url;
                    if (buttonVariables?.[buttonIndex]?.length > 0) {
                        btnConfig.example = buttonVariables[buttonIndex];
                    }
                }
                return btnConfig;
            }),
        };
        cardComponents.push(buttonsComponent);
        return {
            components: cardComponents,
        };
    }
    async createAndSaveTemplates(attachmentComponents, variables, buttonsVariables) {
        const createMessageTemplatePromises = [];
        for (const msg of this.messageTemplate.translations) {
            const componentsToSend = [...attachmentComponents];
            this.addButtonComponents(componentsToSend, msg, buttonsVariables);
            await this.addBodyComponent(componentsToSend, msg, variables);
            this.addFooterComponent(componentsToSend, msg);
            const templatePayload = this.buildTemplatePayload(msg, componentsToSend);
            createMessageTemplatePromises.push(this.MessageTemplateService.set(templatePayload));
        }
        await Promise.all(createMessageTemplatePromises);
    }
    addButtonComponents(componentsToSend, msg, buttonsVariables) {
        if (this.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
            componentsToSend.push({
                type: 'BUTTONS',
                buttons: [{
                        type: 'ORDER_DETAILS',
                        text: 'Copy Pix code',
                    }],
            });
        }
        else if (msg.buttons && msg.buttons.length !== 0) {
            const processedButtons = this.processButtons(msg.buttons, buttonsVariables);
            componentsToSend.push({
                type: 'BUTTONS',
                buttons: processedButtons,
            });
        }
    }
    processButtons(buttons, buttonsVariables) {
        return buttons.map((button, index) => {
            const processedButton = { ...button };
            if (processedButton.url) {
                this.processButtonUrl(processedButton, index, buttonsVariables);
            }
            return processedButton;
        });
    }
    processButtonUrl(processedButton, buttonIndex, buttonsVariables) {
        const buttonVars = this.getMessageTemplateVariables(processedButton.url);
        if (!buttonVars || buttonVars.length === 0) {
            return;
        }
        let normalizedUrl = processedButton.url;
        buttonVars.forEach((varMatch, varIndex) => {
            normalizedUrl = normalizedUrl.replace(varMatch, `{{${varIndex + 1}}}`);
        });
        processedButton.url = normalizedUrl;
        const buttonExample = buttonsVariables.find(bv => bv.buttonIndex === buttonIndex);
        if (buttonExample?.values && buttonExample?.values?.length > 0) {
            const validValues = buttonExample.values.filter(v => v && v.trim() !== '');
            if (validValues.length > 0) {
                processedButton.example = validValues;
            }
        }
    }
    async addBodyComponent(componentsToSend, msg, variables) {
        if (variables.length > 0) {
            this.addBodyWithVariables(componentsToSend, msg, variables);
        }
        else if (this.isAuthenticationType()) {
            await this.addAuthenticationBody(componentsToSend, msg);
        }
        else {
            this.addSimpleBody(componentsToSend, msg);
        }
    }
    addBodyWithVariables(componentsToSend, msg, variables) {
        const text = this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL
            ? msg.bodyText
            : msg.text;
        componentsToSend.push({
            type: 'BODY',
            text: this.replaceNewLines(text),
            example: {
                body_text: variables.length > 0 ? [variables] : variables,
            },
        });
    }
    async addAuthenticationBody(componentsToSend, msg) {
        componentsToSend.push({
            type: 'BODY',
            add_security_recommendation: true,
        });
        const hasButtonsInComponents = componentsToSend.some(c => c.type === 'BUTTONS');
        const hasButtonsInMsg = Array.isArray(msg.buttons) && msg.buttons.length > 0;
        if (!hasButtonsInComponents && !hasButtonsInMsg) {
            const buttonText = getOtpButtonText(msg.language);
            if (buttonText) {
                // Validation already done above, so we can safely use the button text
                componentsToSend.push({
                    type: 'BUTTONS',
                    buttons: [{
                            type: 'OTP',
                            otp_type: 'COPY_CODE',
                            text: buttonText.trim(),
                        }],
                });
            }
            else {
                // Unsupported language: Meta auto-translates (button without text)
                componentsToSend.push({
                    type: 'BUTTONS',
                    buttons: [{
                            type: 'OTP',
                            otp_type: 'COPY_CODE',
                        }],
                });
            }
        }
    }
    addSimpleBody(componentsToSend, msg) {
        const text = this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL
            ? msg.bodyText
            : msg.text;
        componentsToSend.push({
            type: 'BODY',
            text: this.replaceNewLines(text),
        });
    }
    addFooterComponent(componentsToSend, msg) {
        if (msg.footerText) {
            componentsToSend.push({
                type: 'FOOTER',
                text: this.replaceNewLines(msg.footerText),
            });
        }
    }
    buildTemplatePayload(msg, componentsToSend) {
        const templatePayload = {
            name: this.messageTemplate.name,
            components: componentsToSend, // Type conversion needed due to complex union types
            language: msg.language,
            category: this.messageTemplate.category,
            qualityScore: this.messageTemplate.translations[0].qualityScore,
        };
        if (this.shouldShowMetaPricing() && this.isMetaPricingEnabled) {
            templatePayload.bid_spec = {
                bid_amount: Math.round(this.metaBidValue * 100),
            };
        }
        return templatePayload;
    }
    async handleSaveSuccess() {
        const translations = this.messageTemplate.translations
            .map(t => t.language)
            .join(', ');
        this.MessageTemplateSegmentService.trackNewTemplateAdded({
            MessageTemplateName: this.messageTemplate.name,
            MessageTemplateCategory: this.messageTemplate.category,
            MessageTemplateLanguage: translations,
        });
        await this.onSaveMessageTemplate();
        const { name: botName, shortName: botIdentifier } = this.application;
        this.MessageTemplateSegmentService.trackNewTemplateSent({
            templateType: this.messageTemplateType,
            botName,
            botIdentifier,
            buttonType: getTrackedButtonType(this.buttonType, this.messageTemplate.translations[0]?.buttons),
        });
        const successMessage = await this.$translate('messageTemplateSidebar.newTemplate.toasts.success.saveSuccessText');
        this.BlipToastService.show('success', {
            msg: successMessage,
        });
        await this.close();
        document.body.classList.remove('sidebar-open');
    }
    async handleSaveError(error) {
        const messageBase = await this.$translate('messageTemplateSidebar.newTemplate.toasts.error.saveErrorText');
        const isKnownError = error.description && (error.description.includes(TEMPLATE_NAME_ALREADY_EXIST_ERROR_CODE) ||
            error.description.includes(CATEGORY_DOESNT_MATCH_ERROR_CODE));
        if (isKnownError) {
            this.BlipToastService.show('danger', {
                title: messageBase,
                msg: await this.$translate('messageTemplateSidebar.newTemplate.errors.usedMessageTemplateName'),
            });
        }
        else {
            this.BlipToastService.show('danger', {
                title: messageBase,
                msg: error.description || error.message || 'Unknown error',
            });
        }
        await this.close();
        this.LoadingService.stopLoading();
    }
    async uploadAttachment(uri) {
        const { reason, resource } = await this.sendAttachment(uri);
        if (reason) {
            await this.showErrorToast(reason);
            return undefined;
        }
        const { uploadSessionId, fileHandle, fileSize, fileSizeUploaded, } = resource;
        if (fileSize !== fileSizeUploaded) {
            let newFileSizeProgress = fileSizeUploaded;
            let retries = 2;
            do {
                setTimeout(async () => {
                    const { fileSizeUploaded: currentFileSizeUploaded, } = await this.MessageTemplateService.getUploadProgess(uploadSessionId);
                    newFileSizeProgress = currentFileSizeUploaded;
                    retries--;
                }, 2000);
            } while (fileSize !== fileSizeUploaded || retries === 0);
        }
        return fileHandle;
    }
    async saveMessageTemplate() {
        if (!this.isMessageTemplateValid()) {
            const errorMessage = await this.$translate('messageTemplateSidebar.newTemplate.toasts.error.invalidTemplateText');
            this.BlipToastService.show('danger', {
                msg: errorMessage,
            });
            return;
        }
        try {
            // Verifica variáveis no body
            const bodyVars = this.getMessageTemplateVariables(this.messageTemplate.translations[0].text);
            let headerVars = null;
            if (this.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
                headerVars = this.getMessageTemplateVariables(this.messageTemplate.translations[0].headerText);
            }
            const buttonVars = this.getButtonVariables();
            const hasButtonVariables = buttonVars && buttonVars.length > 0;
            let isVariablesInCarousel = false;
            if (this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL) {
                const hasBodyTextVariables = this.messageTemplate.translations[0].bodyTextVariables?.length > 0;
                const hasCardVariables = this.messageTemplate.translations[0].cardVariables?.some(cardVars => cardVars && cardVars.length > 0);
                const hasButtonCardVariables = this.messageTemplate.translations[0].cardButtonVariables?.some(cardButtons => cardButtons?.some(buttonVars => buttonVars && buttonVars.length > 0));
                isVariablesInCarousel = hasCardVariables || hasBodyTextVariables || hasButtonCardVariables;
            }
            if ((bodyVars && bodyVars.length > 0) ||
                (headerVars && headerVars.length > 0) ||
                hasButtonVariables || isVariablesInCarousel) {
                await this.openSampleTemplateModal();
            }
            else {
                await this.openSaveConfirmationModal();
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    saveTranslationText({ value, buttonsArray, }, index) {
        const { name: botName, shortName: botIdentifier } = this.application;
        this.messageTemplate.translations[index].text = value;
        this.options = buttonsArray;
        this.messageTemplate.translations[index].buttons = buttonsArray;
        this.verifyButtonType();
        this.MessageTemplateSegmentService.trackNewTemplateSaved({
            templateType: MessageTemplateContentTypes.TEXT,
            botName,
            botIdentifier,
            buttonType: getTrackedButtonType(this.buttonType, buttonsArray),
        });
        this.aiAnalysis[index] = {
            riskLevel: undefined,
            analysis: undefined,
            suggestedTemplate: undefined,
        };
    }
    saveAttachmentContent({ content, buttonsArray }, index) {
        const { name: botName, shortName: botIdentifier } = this.application;
        const { imageLink, documentLink, videoLink, description, footer, header, headerType, showFooter, } = content;
        this.options = buttonsArray;
        this.messageTemplate.translations[index].buttons = buttonsArray;
        this.verifyButtonType();
        if (imageLink) {
            this.imageLink = imageLink;
            this.messageTemplate.translations[index].imageLink = imageLink;
            this.MessageTemplateSegmentService.trackNewTemplateSaved({
                templateType: MessageTemplateContentTypes.IMAGE,
                botName,
                botIdentifier,
                buttonType: getTrackedButtonType(this.buttonType, buttonsArray),
            });
        }
        else if (videoLink) {
            this.videoLink = videoLink;
            this.messageTemplate.translations[index].videoLink = videoLink;
            this.MessageTemplateSegmentService.trackNewTemplateSaved({
                templateType: MessageTemplateContentTypes.VIDEO,
                botName,
                botIdentifier,
                buttonType: getTrackedButtonType(this.buttonType, buttonsArray),
            });
        }
        else if (this.messageTemplateType === MessageTemplateContentTypes.DOCUMENT) {
            this.documentLink = documentLink;
            this.messageTemplate.translations[index].documentLink = documentLink;
            this.MessageTemplateSegmentService.trackNewTemplateSaved({
                templateType: MessageTemplateContentTypes.DOCUMENT,
                botName,
                botIdentifier,
                buttonType: getTrackedButtonType(this.buttonType, buttonsArray),
            });
        }
        else if (this.messageTemplateType === MessageTemplateContentTypes.PAYMENT) {
            if (imageLink) {
                this.imageLink = imageLink;
                this.messageTemplate.translations[index].imageLink = imageLink;
            }
            if (documentLink) {
                this.documentLink = documentLink;
                this.messageTemplate.translations[index].documentLink = documentLink;
            }
            if (header && headerType === 'text') {
                this.messageTemplate.translations[index].headerText = header;
            }
            this.MessageTemplateSegmentService.trackNewTemplateSaved({
                templateType: MessageTemplateContentTypes.PAYMENT,
                botName,
                botIdentifier,
                buttonType: getTrackedButtonType(this.buttonType, buttonsArray),
            });
        }
        else if (this.messageTemplateType === MessageTemplateContentTypes.CAROUSEL) {
            this.messageTemplate.translations[index].bodyText = content.bodyText;
            this.messageTemplate.translations[index].cards = content.cards;
            this.messageTemplate.translations[index].bodyTextVariables = content.bodyTextVariables;
            this.messageTemplate.translations[index].cardVariables = content.cardVariables;
            this.messageTemplate.translations[index].cardButtonVariables = content.cardButtonVariables;
        }
        this.messageTemplate.translations[index].footerText = footer;
        this.messageTemplate.translations[index].text = description;
    }
    async openSampleTemplateModal() {
        const data = await this.loadModal();
        const modal = await this.ModalService.showModal({
            template: MessageTemplateSampleModalHtml,
            controller: MessageTemplateSampleModalController,
            controllerAs: '$ctrl',
            inputs: {
                modal: data,
            },
        });
        return await modal.close;
    }
    async evaluateMessageRisk(message, type, index) {
        try {
            this.loadingValidateMessateTemplate = true;
            const result = await this.MessageTemplateService.getEvaluateMessage(message, type);
            this.aiAnalysis = this.aiAnalysis || [];
            const riskLevelMapping = {
                High: { riskLevel: 'high', bannerRisk: 'danger' },
                Medium: { riskLevel: 'medium', bannerRisk: 'warning' },
                Low: { riskLevel: 'low', bannerRisk: 'success' },
            };
            const { riskLevel, bannerRisk } = riskLevelMapping[result.riskLevel] || {};
            this.aiAnalysis[index] = {
                riskLevel,
                bannerRisk,
                analysis: result.analysis,
                suggestedTemplate: result.suggestedTemplate,
            };
        }
        catch (error) {
            console.error('Error validate template message risk:', error);
            this.showValidateTemplateFailiureToast(error);
        }
        finally {
            this.loadingValidateMessateTemplate = false;
        }
    }
    async copyToClipboard(text) {
        if (!navigator.clipboard) {
            return false;
        }
        this.loadingAnalysis = true;
        try {
            await navigator.clipboard.writeText(text);
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
        finally {
            setTimeout(() => {
                this.loadingAnalysis = false;
            }, 50);
        }
    }
    async openSaveConfirmationModal() {
        await this.AlertService.show({
            title: await this.$translate('messageTemplate.modal.saveModal.title'),
            body: await this.$translate('messageTemplate.modal.saveModal.text', {
                templateType: this.messageTemplateType,
            }),
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: await this.$translate('messageTemplate.modal.saveModal.cancelButton'),
                confirm: await this.$translate('utils.forms.confirm'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: async () => {
                    this.saveTemplate();
                },
            },
        });
    }
    getPaymentCardController() {
        try {
            const paymentCardElement = document.querySelector('message-template-payment-card');
            if (paymentCardElement) {
                return angular
                    .element(paymentCardElement)
                    .controller('messageTemplatePaymentCard');
            }
        }
        catch (error) {
            console.error('Error getting payment card controller:');
        }
        return null;
    }
    getCurrentHeaderValue() {
        const paymentCardController = this.getPaymentCardController();
        if (paymentCardController && paymentCardController.$scope) {
            return paymentCardController.$scope.headerValue || '';
        }
        return '';
    }
    getCurrentFooterValue() {
        const paymentCardController = this.getPaymentCardController();
        if (paymentCardController && paymentCardController.$scope) {
            return paymentCardController.$scope.footerValue || '';
        }
        return '';
    }
    getCurrentPaymentCardSettings() {
        const paymentCardController = this.getPaymentCardController();
        if (paymentCardController) {
            return {
                headerType: paymentCardController.selectedHeaderType || 'text',
                showFooter: paymentCardController.showFooterPayment !== undefined
                    ? paymentCardController.showFooterPayment
                    : true,
                imageLink: paymentCardController.imagePaymentLink || '',
                documentLink: paymentCardController.documentLink || '',
            };
        }
        return {
            headerType: 'text',
            showFooter: true,
            imageLink: '',
            documentLink: '',
        };
    }
    async loadModal() {
        const config = {
            messageTemplate: this.messageTemplate,
            messageTemplateType: this.messageTemplateType,
            mediaLinks: {
                video: this.videoLink,
                image: this.imageLink,
                document: this.documentLink,
            },
            translateService: this.$translate,
            variableExtractors: {
                getText: (text) => this.getMessageTemplateVariables(text),
                getButtons: () => this.getButtonVariables(),
            },
            paymentExtractors: this.messageTemplateType === MessageTemplateContentTypes.PAYMENT ? {
                getHeaderValue: () => this.getCurrentHeaderValue(),
                getFooterValue: () => this.getCurrentFooterValue(),
                getSettings: () => this.getCurrentPaymentCardSettings(),
            } : undefined,
            callbacks: {
                onSave: (data) => {
                    this.saveTemplate(data.bodyVariables, data.buttonVariables, data.headerVariables, data.carouselCardVariables, data.cardButtonVariables);
                },
                onCancel: () => this.ModalService.closeModals(),
            },
        };
        const builder = new MessageTemplateModalBuilder(config);
        return await builder.build();
    }
    getMessageTemplateVariables(text) {
        if (text) {
            return text.match(/{{\d{1,10}}}/gm) || undefined;
        }
        return undefined;
    }
    messageTemplateHasVariables() {
        this.messageTemplate.translations[0].buttons = !this.messageTemplate
            .translations[0].buttons
            ? []
            : this.messageTemplate.translations[0].buttons;
        const buttonUrl = this.messageTemplate.translations[0].buttons.find(button => button.url?.length > 0);
        const textHasVariables = this.getMessageTemplateVariables(this.messageTemplate.translations[0].text) !== undefined;
        let headerHasVariables = false;
        if (this.messageTemplateType === MessageTemplateContentTypes.PAYMENT &&
            this.messageTemplate.translations[0].headerText) {
            headerHasVariables =
                this.getMessageTemplateVariables(this.messageTemplate.translations[0].headerText) !== undefined;
        }
        const buttonHasVariables = this.messageTemplate.translations[0].buttons.some(button => button.url &&
            this.getMessageTemplateVariables(button.url) !== undefined);
        const hasVariables = textHasVariables || headerHasVariables || buttonHasVariables;
        return hasVariables;
    }
    getButtonVariables() {
        const buttons = this.messageTemplate.translations[0].buttons || [];
        const buttonVariables = [];
        buttons.forEach((button, index) => {
            if (button.url) {
                const vars = this.getMessageTemplateVariables(button.url);
                if (vars && vars.length > 0) {
                    buttonVariables.push({
                        buttonIndex: index,
                        buttonText: button.text,
                        url: button.url,
                        variables: vars,
                    });
                }
            }
        });
        return buttonVariables;
    }
    getCarouselButtonVariables() {
        const cards = this.messageTemplate.translations[0].cards || [];
        const buttonVariables = [];
        cards.forEach((card, cardIndex) => {
            const buttons = card.buttons || [];
            buttons.forEach((button, buttonIndex) => {
                if (button.url) {
                    const vars = this.getMessageTemplateVariables(button.url);
                    if (vars && vars.length > 0) {
                        buttonVariables.push({
                            cardIndex: cardIndex,
                            buttonIndex: buttonIndex,
                            buttonText: button.text,
                            url: button.url,
                            variables: vars,
                        });
                    }
                }
            });
        });
        return buttonVariables;
    }
    async sendAttachment(uri) {
        let resource;
        let reason;
        if (this.isNewMessageAttachmentRouteEnabled) {
            ({
                resource,
                reason,
            } = await this.MessageTemplateService.uploadAttachmentV2({
                media: {
                    uri,
                },
                type: this.messageTemplateType,
            }));
        }
        else {
            ({
                resource,
                reason,
            } = await this.MessageTemplateService.uploadAttachment({
                uri,
            }));
        }
        return { reason, resource };
    }
    async showErrorToast(reason) {
        let errorTitle;
        let errorDescription;
        ({ errorTitle, errorDescription } = await this.handleErrorType(reason));
        this.BlipToastService.show('danger', {
            title: errorTitle,
            msg: errorDescription,
        });
    }
    async handleErrorType(reason) {
        let errorTitle;
        let errorDescription;
        if (reason.code === COMMAND_INVALID_ARGUMENT_CODE) {
            if (reason.description.startsWith(INVALID_SIZE_ERROR_TEXT)) {
                ({
                    errorTitle,
                    errorDescription,
                } = await this.defineErroTitleAndDescription('messageTemplateSidebar.newTemplate.errors.fileSize.title', 'messageTemplateSidebar.newTemplate.errors.fileSize.description'));
            }
            else if (reason.description.startsWith(UNSUPPORTED_TYPE_ERROR_TEXT) ||
                reason.description.startsWith(MISMATCHED_TYPE_ERROR_TEXT)) {
                if (this.messageTemplateType ==
                    MessageTemplateContentTypes.IMAGE) {
                    ({
                        errorTitle,
                        errorDescription,
                    } = await this.defineErroTitleAndDescription('messageTemplateSidebar.newTemplate.errors.imageFormat.title', 'messageTemplateSidebar.newTemplate.errors.imageFormat.description'));
                }
                else if (this.messageTemplateType ==
                    MessageTemplateContentTypes.DOCUMENT) {
                    ({
                        errorTitle,
                        errorDescription,
                    } = await this.defineErroTitleAndDescription('messageTemplateSidebar.newTemplate.errors.documentFormat.title', 'messageTemplateSidebar.newTemplate.errors.documentFormat.description'));
                }
                else if (this.messageTemplateType ==
                    MessageTemplateContentTypes.VIDEO) {
                    ({
                        errorTitle,
                        errorDescription,
                    } = await this.defineErroTitleAndDescription('messageTemplateSidebar.newTemplate.errors.videoFormat.title', 'messageTemplateSidebar.newTemplate.errors.videoFormat.description'));
                }
            }
        }
        else {
            ({
                errorTitle,
                errorDescription,
            } = await this.defineErroTitleAndDescription('messageTemplateSidebar.newTemplate.errors.unmappedError.title', 'messageTemplateSidebar.newTemplate.errors.unmappedError.description'));
        }
        return { errorTitle, errorDescription };
    }
    async defineErroTitleAndDescription(title, description) {
        const errorTitle = await this.$translate(title);
        const errorDescription = await this.$translate(description);
        return { errorTitle, errorDescription };
    }
    async showValidateTemplateFailiureToast(e) {
        const messageBase = await this.$translate('messageTemplateSidebar.newTemplate.toasts.error.saveErrorText');
        this.BlipToastService.show('danger', {
            title: messageBase,
            msg: await this.$translate('messageTemplateSidebar.newTemplate.errors.validateErrorText'),
        });
    }
}
CreateMessageTemplateSidebarController.$inject = ['close', 'AccountService2', 'messageTemplate', 'messageTemplates', 'type', 'application', '$translate', 'MessageTemplateService', 'MessageTemplateSegmentService', 'ModalService', 'LoadingService', 'onSaveMessageTemplate', 'BlipToastService', 'AlertService', '$scope'];
